/**
 * Email validation regex pattern
 */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validates email format
 * @param {string} email - Email address to validate
 * @returns {boolean} True if valid email format
 */
export const isValidEmail = (email) => EMAIL_REGEX.test((email || "").trim());

/**
 * List of allowed impersonator emails
 * Add more allowed emails here
 */
export const ALLOWED_IMPERSONATORS = [
  "sagar.mane@pidilite.com",
  "rishabh.sharma@pidilite.com",
];
